<template>  
  <CHeader fixed withSubHeader light>
    <CToggler
    in-header
    class="ml-2 d-lg-none"
    @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-2 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <img src="../assets/images/logo-h-small.png" alt="">
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink :to="{ name: 'Dashboard'}">
          Menu Utama
        </CHeaderNavLink>
      </CHeaderNavItem>
    </CHeaderNav>
    <CHeaderNav>
      <CHeaderNavItem class="d-md-down-none ml-auto mr-2">
        Selamat Datang, <span class="font-weight-bold">{{emailUserLogIn}}</span>
      </CHeaderNavItem>
    </CHeaderNav>
    <!-- <CHeaderNav>
      <CHeaderNavItem>
        <CIcon name="cil-home" size="xl"></CIcon>
      </CHeaderNavItem>
    </CHeaderNav> -->
  </CHeader>
</template>

<style scoped>
  .c-icon {
    margin-right: 0.5rem;
  }
</style>


<script>
  export default {
    name: "TheHeader",
    data(){
      return {
        emailUserLogIn: 'jon-doe@gmail.com'
      }
    },
    created(){
      this.emailUserLogIn = localStorage.getItem(this.$appType+'emailUser');
    }
  }
</script>